import { gql } from '@apollo/client'

export const GET_ALL_STATUS_ROLES_VISIBILITY_BY_STATUS_ID = gql`
  query GetAllStatusRolesVisibilityByStatusId($status_id: Int!) {
    getAllStatusRolesVisibilityByStatusId(status_id: $status_id) {
      id
      status_id
      role_id
      RoleData {
        role_name
        description
      }
    }
  }
`

export const GET_ALL_STATUS_ROLES_BY_TYPE_STATUS_OF_USER_CONTEXT = gql`
query GetAllStatusRoleByTypeStatusOfUserContext($type_status: String!) {
  getAllStatusRoleByTypeStatusOfUserContext(type_status: $type_status) {
    status_id
    status_data {
      id
      name
      type
      description
      progress
      color
      order
    }
  }
}
`

export const CREATE_STATUS_ROLE_VISIBILITY = gql`
  mutation CreateStatusRoleVisibility($status_id: Int!, $role_id: Int!) {
    createStatusRoleVisibility(status_id: $status_id, role_id: $role_id) {
      id
    }
  }
`

export const DELETE_STATUS_ROLE_VISIBILITY = gql`
  mutation DeleteStatusRoleVisibility($id: Int!) {
    deleteStatusRoleVisibility(id: $id)
  }
`

export const GET_ALL_ROLES_AVAILABLE_TO_STATUS_ROLES_VISIBILITY = gql`
  query GetAllRolesAvailabesNotInStatusRolesVisibility($status_id: Int!) {
    getAllRolesAvailabesNotInStatusRolesVisibility(status_id: $status_id) {
      id
      role_name
      description
    }
  }
`
